import { render, staticRenderFns } from "./ChangeShareDocumentForm.vue?vue&type=template&id=2dace726&scoped=true"
import script from "./ChangeShareDocumentForm.vue?vue&type=script&lang=ts"
export * from "./ChangeShareDocumentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dace726",
  null
  
)

export default component.exports